'use client';

import React, { lazy, useEffect, useState } from 'react';
import useGlobalState from '@hooks/useGlobalState';
import { useScrollRestoration } from '@hooks/restoreScrollPosition';
import DesktopHeaderLayoutContainer from '@components/pages/common/DesktopHeaderLayoutContainer';
import HeaderLayout from '@components/pages/common/HeaderLayoutContainer';
import { BrandPageServerProps } from '@models/brand';
import { useLoading } from '@contexts/LoadingContext';
import { useSearchParams } from 'next/navigation';
import useAirBridgeEvent from '@hooks/useAirBridgeEvent';
import { BiLogo } from '@wconcept/wconcept-common/models/renewal/popup';
import BrandPageContent from '../BrandPageContent';

const pageClassName = 'brand-page';

export default function BrandPageContainer() {
  const { initialData, isMobile } = useGlobalState<BrandPageServerProps>();
  const { isAllLoaded } = useLoading(['brandConnerList', 'brandProductList']);
  const [pageName, setPageName] = useState('브랜드관');
  useScrollRestoration(isAllLoaded);
  const searchParams = useSearchParams();
  const { openAirBridgeAppBanner } = useAirBridgeEvent();

  useEffect(() => {
    if (!isMobile) return;

    const handleScroll = () => {
      const $nameKo = document.querySelector('.corner-brand-main .name-ko');
      if (!$nameKo) return;

      const nameKoTop = $nameKo.getBoundingClientRect().top;
      const point = nameKoTop + window.pageYOffset;
      const scrollY = -document.body.getBoundingClientRect().top;

      setPageName(
        point < scrollY ? initialData?.brandInfo?.brandNameKr || '' : '브랜드관'
      );
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll);
    // eslint-disable-next-line consistent-return
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isMobile]);

  useEffect(() => {
    openAirBridgeAppBanner();
  }, [openAirBridgeAppBanner]);

  return (
    <>
      {!isMobile ? (
        <DesktopHeaderLayoutContainer
          className={pageClassName}
          pageTitle="브랜드관"
          isHistoryBtn
          megaMenu={initialData?.megaMenu}
          gnbInfo={initialData?.gnbInfo || []}
          searchInitInfo={initialData?.searchInitInfo}
        >
          <BrandPageContent />
        </DesktopHeaderLayoutContainer>
      ) : (
        <HeaderLayout
          gnbType={searchParams?.get('gnbType') || 'N'}
          className={pageClassName}
          gnbInfo={initialData?.gnbInfo}
          selectedGnbValue="rn/brand"
          pageTitle={pageName}
          isShortFormBtn={false}
          subHeaderType="subDetail"
          isProfileBtn={false}
          isHistoryBtn
          logoInfo={initialData?.logoInfo?.biLogo as BiLogo}
          isFooter={false}
        >
          <BrandPageContent />
        </HeaderLayout>
      )}
    </>
  );
}
